
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Button, TableFooter, TablePagination, Box, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, MenuItem, Grid, Card, CardContent, CardHeader, FormControl, InputLabel, Select, SelectChangeEvent, TextField, Divider, Checkbox, ListItemText, Collapse, IconButton } from "@mui/material";

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import MoveUpIcon from '@mui/icons-material/MoveUp';

import moment from 'moment';

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { GetColorMap } from "../../helpers/GetColor";

import { usePages } from "../../hooks/usePages";

import { setReducerLoading } from "../../store/slices/LoadingSlice";
import { setReducerBandeja } from "../../store/slices/BandejaReducer";
import { RootState } from "../../store";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";
import { DialogActionsStyle, DialogContentStyle, DialogTitleStyle } from "../../styles/DialogStyle";

import { Layout } from "../../components/Layout";
import { AlertFirmaElectronica } from "../../components/AlertFirmaElectronica";
import { CircularProgressIndicator } from "../../components/CircularProgressIndicator";

import { AsignarActividad, MostrarInbox } from "../../connections/comun/InboxConnection";

import { defaultInbox, InboxProps } from "../../interfaces/comun/InboxInterface";

export const InboxPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { open } = useSelector( ( state: RootState ) => state.loading );
    const { open: openBandeja } = useSelector( ( state: RootState ) => state.bandeja );

    const [rows, setRows] = useState<InboxProps[]>( [] );

    const [filtrosExpanded, setFiltrosExpanded] = useState( false );

    const [filterProceso, setFilterProceso] = useState<string[]>( [] );
    const [filterActividad, setFilterActividad] = useState<string[]>( [] );
    const [filterFecha, setFilterFecha] = useState<moment.Moment | null>( null );
    const [filterReferencia, setFilterReferencia] = useState( '' );
    const [filterFolio, setFilterFolio] = useState( '' );

    const procesoOptions = Array.from( new Set( rows.map( r => r.proceso ).filter( Boolean ) ) );
    const actividadOptions = Array.from( new Set( rows.map( r => r.actividad ).filter( Boolean ) ) );

    const actividadColorMap = GetColorMap( actividadOptions );

    const actividadCount = rows.reduce<Record<string, number>>( (acc, r) => {
        if ( r.actividad ) acc[ r.actividad ] = ( acc[ r.actividad ] ?? 0 ) + 1;
        return acc;
    }, {} );

    const filteredRows = rows.filter( row => {

        const matchProceso = filterProceso.length === 0 || filterProceso.includes( row.proceso );
        const matchActividad = filterActividad.length === 0 || filterActividad.includes( row.actividad );

        const fecha = row.fechaOrder ? moment( row.fechaOrder ) : null;
        const matchFecha = !filterFecha || ( fecha !== null && fecha.isSame( filterFecha, 'day' ) );

        const matchReferencia = filterReferencia === '' ||
            row.referencia.toLowerCase().includes( filterReferencia.toLowerCase() ) ||
            row.noReferencia.toLowerCase().includes( filterReferencia.toLowerCase() );

        const matchFolio = filterFolio === '' ||
            row.folioBuzonElectronico.toLowerCase().includes( filterFolio.toLowerCase() );

        return matchProceso && matchActividad && matchFecha && matchReferencia && matchFolio;
    });

    const [caso, setCaso] = useState<InboxProps>( defaultInbox );
    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [loadingAsignar, setLoadingAsignar] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 500 );

    const handleAsignarActividad = async () => {

        setLoadingAsignar( true );

        const { numeroSeguimiento, path } = caso

        await AsignarActividad({ numeroSeguimiento }).then( resp => {

            const { success  } = resp;

            if ( success ) {

                setTimeout(() => {

                    setLoadingAsignar( false );
                    setOpenConfirmacion( false );

                    navigate( path );

                }, 700);

            }
            else {
                setLoadingAsignar( false );
            }

        });

    }

    useEffect(() => {

        async function Obtener() {

            dispatch( setReducerLoading( { open: true } ) );

            await MostrarInbox().then( resp => {

                setTimeout(() => {

                    setRows( resp );
                    dispatch( setReducerLoading( { open: false } ) );

                }, 700);

            });

        }

        Obtener();

    }, [ dispatch ])

    useEffect(() => {

        async function Obtener() {

            dispatch( setReducerLoading( { open: true } ) );

            await MostrarInbox().then( resp => {

                setTimeout(() => {

                    setRows( resp );
                    dispatch( setReducerLoading( { open: false } ) );
                    dispatch( setReducerBandeja({ open: false }) );

                }, 700);

            });

        }

        if ( openBandeja ) {
            Obtener();
        }

    }, [ dispatch, openBandeja ])

    return (

        <Layout breadcrumbs={ [{ text: 'Bandeja' }] } backgroundPaper={ false }>

            {
                open
                ?
                    <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 500 }}>
                        <CircularProgressIndicator mt={ 25 } />
                    </Box>
                :
                    <>

                        <AlertFirmaElectronica />

                        <Card sx={{ mb: 2 }}>

                            <CardHeader
                                title={
                                    <Typography variant="subtitle1" fontWeight="bold" color="white">
                                        Filtros
                                    </Typography>
                                }
                                action={
                                    <IconButton
                                        onClick={ (e) => { e.stopPropagation(); setFiltrosExpanded( prev => !prev ); } }
                                        sx={{
                                            color: 'white',
                                            transform: filtrosExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s',
                                        }}
                                    >
                                        <ExpandMoreIcon />
                                    </IconButton>
                                }
                                sx={{ backgroundColor: 'primary.main', py: 1.5, cursor: 'pointer' }}
                                onClick={ () => setFiltrosExpanded( prev => !prev ) }
                            />

                            <Collapse in={ filtrosExpanded } timeout={ 200 }>

                                <Divider />

                                <CardContent sx={{ py: 3 }}>

                                    <Grid container spacing={ 3 }>

                                        <Grid size={{ xs: 12, sm: 2 }}>

                                            <FormControl fullWidth>

                                                <InputLabel shrink>Proceso</InputLabel>

                                                <Select<string[]>
                                                    multiple
                                                    displayEmpty
                                                    label="Proceso"
                                                    value={ filterProceso }
                                                    onChange={ ( e: SelectChangeEvent<string[]> ) => {

                                                        const value = e.target.value as string[];

                                                        if ( value.includes( 'Todos' ) ) {
                                                            setFilterProceso( [] );
                                                        }
                                                        else {
                                                            setFilterProceso( value );
                                                        }

                                                    }}
                                                    renderValue={ (selected) => selected.length === 0 ? 'Todos' : selected.join( ', ' ) }
                                                >
                                                    <MenuItem value="Todos">
                                                        <Checkbox checked={ filterProceso.length === 0 } />
                                                        <ListItemText primary="Todos" />
                                                    </MenuItem>

                                                    {
                                                        procesoOptions.map( (p: string) => (
                                                            <MenuItem key={ p } value={ p }>
                                                                <Checkbox checked={ filterProceso.includes( p ) } />
                                                                <ListItemText primary={ p } />
                                                            </MenuItem>
                                                        ))
                                                    }

                                                </Select>

                                            </FormControl>

                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 3 }}>

                                            <FormControl fullWidth>

                                                <InputLabel shrink>Actividad</InputLabel>

                                                <Select<string[]>
                                                    multiple
                                                    displayEmpty
                                                    label="Actividad"
                                                    value={ filterActividad }
                                                    onChange={ ( e: SelectChangeEvent<string[]> ) => {

                                                        const value = e.target.value as string[];

                                                        if ( value.includes( 'Todas' ) ) {
                                                            setFilterActividad( [] );
                                                        }
                                                        else {
                                                            setFilterActividad( value );
                                                        }
                                                    }}
                                                    renderValue={ (selected) => selected.length === 0 ? 'Todas' : selected.join( ', ' ) }
                                                >
                                                    <MenuItem value="Todas">
                                                        <Checkbox checked={ filterActividad.length === 0 } />
                                                        <ListItemText primary="Todas" />
                                                    </MenuItem>

                                                    {
                                                        actividadOptions.map( (a) => (
                                                            <MenuItem key={ a } value={ a }>
                                                                <Checkbox checked={ filterActividad.includes( a ) } />

                                                                <ListItemText primary={
                                                                    <span>{ a } <strong>({ actividadCount[ a ] ?? 0 })</strong></span>
                                                                } />

                                                                <Box sx={{ width: '15px', height: '15px', borderRadius: '2px', backgroundColor: actividadColorMap[ a ], ml: 1, flexShrink: 0 }} />
                                                            </MenuItem>
                                                        ))
                                                    }

                                                </Select>

                                            </FormControl>

                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 2 }}>

                                            <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">

                                                <DatePicker
                                                    label="Fecha"
                                                    value={ filterFecha }
                                                    sx={{ width: '100%' }}
                                                    onChange={ (e) => setFilterFecha( e ) }
                                                    slotProps={{ field: { clearable: true }, textField: { InputLabelProps: { shrink: true } } }}
                                                />

                                            </LocalizationProvider>

                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 3 }}>

                                            <TextField
                                                fullWidth
                                                label="Referencia"
                                                placeholder="Escribe el número de referencia"
                                                value={ filterReferencia }
                                                onChange={ (e) => setFilterReferencia( e.target.value ) }
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}
                                            />

                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 2 }}>

                                            <TextField
                                                fullWidth
                                                label="Folio buzón electrónico"
                                                placeholder="Escribe el folio"
                                                value={ filterFolio }
                                                onChange={ (e) => setFilterFolio( e.target.value ) }
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}
                                            />

                                        </Grid>

                                    </Grid>

                                </CardContent>

                            </Collapse>

                        </Card>

                        <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                            <Table sx={{ minHeight: filteredRows.length === 0 ? 450 : 0 }}>

                                <TableHead sx={{ ...TableTheadStyle }}>

                                    <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Número de <br /> seguimiento</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Proceso</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Actividad</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Fecha</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Referencia</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold' }}></TableCell>

                                    </TableRow>

                                </TableHead>

                                <TableBody>

                                    {
                                        (
                                            rowsPerPage > 0
                                            ?
                                                filteredRows.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                            :
                                                filteredRows
                                        ).map( ( row, index ) => (

                                            <TableRow key={ index } >

                                                <TableCell sx={{ textAlign: 'center', fontWeight: 'Bold' }} > { row.numeroSeguimiento } </TableCell>

                                                <TableCell>
                                                    <strong style={{ fontSize: 15 }}>{  row.proceso } </strong> <br />
                                                    <small style={{ fontSize: 13 }}> { row.tipoTramite && " (" + row.tipoTramite + ")" } </small>
                                                </TableCell>

                                                <TableCell>

                                                    <Box sx={{ display: 'flex', alignItems: 'stretch', borderRadius: '6px', overflow: 'hidden', width: 'fit-content' }}>

                                                        <Box sx={{ width: '15px', backgroundColor: actividadColorMap[ row.actividad ], flexShrink: 0 }} />

                                                        <Button
                                                            variant='contained'
                                                            size='small'
                                                            sx={{ textAlign: 'left', textTransform: 'none', borderRadius: '0 4px 4px 0' }}
                                                            onClick={() => {

                                                                if ( row.delegado ) {
                                                                    setCaso( row );
                                                                    setOpenConfirmacion( true );
                                                                }
                                                                else {
                                                                    navigate( row.path );
                                                                }

                                                            }}
                                                            startIcon={ <BusinessCenterIcon /> }
                                                        >
                                                            { row.actividad }
                                                        </Button>

                                                    </Box>

                                                </TableCell>

                                                <TableCell> { row.fecha } </TableCell>

                                                <TableCell>
                                                    {
                                                        ( row.noReferencia && row.referencia )
                                                        ?
                                                            <>
                                                                <Typography fontWeight={ 'bold' } fontSize={ 14 }>{ row.referencia }</Typography>
                                                                <Typography fontSize={ 12 } mt={ 1 }>{ row.noReferencia }</Typography>
                                                            </>
                                                        :
                                                            <Typography fontWeight={ 'bold' } fontSize={ 14 }>{ row.referencia }</Typography>
                                                    }
                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}>

                                                    {
                                                        row?.provieneBuzonElectronico
                                                        &&
                                                            <Chip
                                                                variant='outlined'
                                                                color="secondary"
                                                                sx={{ p: 2 }}
                                                                icon={ <ForwardToInboxIcon fontSize="small" /> }
                                                                label={
                                                                    <Typography variant="button" fontWeight={ '600' } sx={{ ml: 1 }}>
                                                                        { row?.folioBuzonElectronico }
                                                                    </Typography>
                                                                }
                                                            />
                                                    }

                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}>

                                                    { row.delegado && <MoveUpIcon sx={{ ml: 2, marginTop: '5px' }} /> }

                                                </TableCell>

                                            </TableRow>

                                        ))
                                    }

                                    {
                                        filteredRows.length === 0 &&
                                        (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={ 7 }
                                                    align="center"
                                                >
                                                    <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }

                                </TableBody>

                                <TableFooter>

                                    <TableRow>

                                        <TableCell colSpan={ 2 }>
                                            <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { filteredRows.length } </Typography>
                                        </TableCell>

                                        <TablePagination
                                            colSpan={ 7 }
                                            rowsPerPageOptions={[ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ]}
                                            count={ filteredRows.length }
                                            rowsPerPage={ rowsPerPage }
                                            page={ page }
                                            onPageChange={ handleChangePage }
                                            onRowsPerPageChange={ handleChangeRowsPerPage }

                                            ActionsComponent={ TablePaginationActions }

                                            labelRowsPerPage="Filas por página"
                                            labelDisplayedRows={
                                                ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                                }
                                            }
                                        />
                                    </TableRow>

                                </TableFooter>

                            </Table>

                        </TableContainer>

                        <Dialog open={ openConfirmacion } onClose={ () => {} } >

                            <DialogTitle sx={ DialogTitleStyle }>
                                Confirmación
                            </DialogTitle>

                            <DialogContent sx={ DialogContentStyle }>

                                <DialogContentText sx={{ color: 'rgba(0, 0, 0, 0.8)' }} mt={ 3 }>
                                    ¿Desea asignar la actividad <strong>{ caso?.actividad ?? '' } ({ caso.numeroSeguimiento }) </strong> de <strong>{ caso?.usuarioDelegado ?? '' }</strong> a su cuenta?
                                </DialogContentText>

                            </DialogContent>

                            <DialogActions sx={ DialogActionsStyle }>
                                <Button color="secondary" disabled={ loadingAsignar } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>

                                <Button
                                    onClick={ handleAsignarActividad }
                                    variant='contained'
                                    loading={ loadingAsignar }
                                >
                                    Aceptar
                                </Button>

                            </DialogActions>

                        </Dialog>

                    </>
            }

        </Layout>
    )
}
